export default __webpack_public_path__ + "static/ai-genai-2a1fdfe46b9f59f64b977fb125260299.png";